import { graphql } from "../../generated";

export const campaignsQuery = graphql(/* GraphQL */ `
    query Campaigns($client: String!, $state: CampaignState, $limit: Int, $nextToken: String) {
        campaigns(client: $client, state: $state, limit: $limit, nextToken: $nextToken) {
            nextToken
            items {
                ...campaignItemFields
            }
        }
    }
`);

export const campaignQuery = graphql(/* GraphQL */ `
    query Campaign($campaignId: String!) {
        campaign(campaignId: $campaignId) {
            ...campaignDetailFields
        }
    }
`);

export const campaignProductReviewDestinationsQuery = graphql(/* GraphQL */ `
    query CampaignProductReviewDestinations($campaignId: String!) {
        campaign(campaignId: $campaignId) {
            id
            productReviewDestinations {
                productId
                destinations {
                    type
                    key
                    name
                    config
                }
            }
        }
    }
`);

export const campaignQuestionnaireQuery = graphql(/* GraphQL */ `
    query CampaignQuestionnaire($campaignId: String!) {
        campaign(campaignId: $campaignId) {
            id
            questionnaire {
                id
                questions {
                    key
                    type
                    isOptional
                    text
                    options {
                        key
                        text
                    }
                }
            }
        }
    }
`);
